<template>
    <div class="wallet">
        <!-- INCIO TÍTULO PÁGINA -->
        <div class="row align-items-center wallet__tit-page tit_page">
            <div class="col-8 col-md-8 col-lg-8 d-flex align-items-center">
                <h1>Adicionar fundos</h1>
            </div>
            <div class="col-4 col-md-4 col-lg-4">
                <div class="back back-hide float-right">
                    <router-link to="/investimentos/carteira-investimento" title="Voltar"><i>&nbsp;</i> voltar</router-link>
                </div>
            </div>
        </div>
        <!-- FINTAL TÍTULO PÁGINA -->

        <div class="row">
            <div class="col-12">
                <div class="funds-transfer__actions box-border">
                    <!-- INICIO BLOCO FORMULARIO ADICIONAR FUNDOS -->
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <form>
                                <fieldset>
                                    <h2>Digite quanto você quer incluir em sua Carteira Virtual</h2>
                                    <input type="tel" class="form-control form-control-lg" placeholder="R$ 100,00" v-model="valueSaqueDate" v-mask="'money'">
                                    <button class="btn btn-primary btn-lg btn-block" disabled>Confirmar</button>
                                    <!-- OBSERVAÇÃO: os botões ficam desativados, é ativado a partir do momento do preechimento do campo. -->
                                    <router-link to="" title="Cancelar" class="btn btn-link">Cancelar</router-link>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                    <!-- FINAL BLOCO FORMULARIO ADICIONAR FUNDOS -->

                    <!-- INICIO BLOCO COMPROVANTE / BOLETO -->
                    <div class="row justify-content-center"  style="display:none;">
                        <div class="col-12 col-md-12 col-lg-7">

                            <div class="row align-items-center comprovante">
                                <div class="col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end">

                                <!-- INÍCIO COMPROVANTE -->
                                    <div class="coupon" id="cupom">
                                        <div class="coupon__head"></div>
                                        <div class="coupon__body">
                                            <img src="/static/assets/images/logotipo-iouu.png" width="70" alt="Logotipo IOUU">
                                            <p class="id">COMPROVANTE 0000</p>
                                            <div class="date">
                                                EFETUADO EM: <span>00/00/0000</span>
                                            </div>
                                            <ul>
                                                <li>Para: <span>Alexsander Macedo</span></li>
                                                <li>CPF: <span>000.000.000-00</span></li>
                                                <li>Carteria virutal: <span>100001</span></li>
                                                <li>Valor do depósito: <span>R$ 500,00</span></li>
                                                <li>
                                                    <p class="obs">
                                                        O depósito será confirmado somente após a aprovação do pagamento. Prazo para confirmação de pagamento de boleto é de até 72 horas.
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="coupon__foot"></div>
                                    </div>
                                    <!-- FINAL COMPROVANTE -->

                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="wallet__description">
                                        <h2>Depósito em carteira virtual</h2>
                                        <div>
                                            <p>
                                                <strong class="text-black-50">Deposito para:</strong>
                                                <span class="text-dark">Alexsander Macedo</span>
                                                <span class="small">049.070.089.61</span>
                                            </p>
                                            <p>
                                                <strong class="text-black-50">Valor do depósito:</strong>
                                                <span class="text-success">R$ 500,00</span>
                                            </p>

                                            <img src="/static/assets/images/ico-boleto.svg" width="52px" alt="Icone Boleto">
                                            <a href="#" class="btn btn-primary btn-lg">Gerar Boleto</a>
                                            <!-- Após clicar em gerar boleto, alterar o texto para Visualizar boleto, abrindo em uma nova janela o pdf referente ao boleto -->

                                            <p class="small">
                                                O depósito será confirmado somente após a aprovação do pagamento. Prazo para confirmação de pagamento de boleto é de até 72 horas.
                                            </p>
                                        </div>
                                        <button class="btn btn-outline-secondary btn-lg" title="Imprimir boleto"><i class="fas fa-print"></i> Imprimir comprovante</button>
                                        <button class="btn btn-outline-secondary btn-lg" title="Salvar comprovante"><i class="fas fa-download"></i> Salvar comprovante</button>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <!-- FINAL BLOCO COMPROVANTE / BOLETO -->
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/carteira-investimento/adicionar-fundos',
                    title: 'AdicionarFundos',
                })
            },
        },
        async created() {
            //tagueamento GA
            await this.taggingGA();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    form {
        fieldset {
            padding-top:170px;
            padding-bottom:170px;
        }
        h2 {
            @include font-size(25px);   
        }
        button {
            margin-top: 15px;
        }

        .btn-link {
            text-transform: uppercase;

            &:hover {
                color: $c3;
            }
        }
    }
    .coupon {
        padding-top: 100px;
        padding-bottom: 100px;

        &__body {
            .obs {
                padding-top: 14px!important;
                @include font-size(11px);
                margin:0px;
            }
        }

        @include xs {
            padding-top: 20px;
            padding-bottom: 20px;
        }

        @include sm {
            padding-top: 20px;
            padding-bottom: 20px;
        }        
    }

    .wallet__description {
        p {
            span {
                &.small {
                    @include font-size(14px);  
                    color: #999;   
                }
            }
        }

        .btn {
            &-primary {
                @include font-size(15px);
                font-weight: bold;
                text-transform: uppercase;
                height: 40px;
                line-height: 40px;
                padding: 0 30px;
                margin-left: 10px;
                border: #40CD28;
                background: #40CD28;

                &:hover {
                    border: #39b824;
                    background: #39b824;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/WalletAddCash.vue